// extracted by mini-css-extract-plugin
export default {"contents":"wH-z","sectionHeading":"xH-z"};